/* eslint-disable */
import React, { useMemo,useState,useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useStore } from '../../../../store';
import {CTitle, STitle, TTitle} from '../../components/Widget';
import QRightBg from './../../../../../../assets/finance/topic900/q_right_bg.png';
import { useUpdateComponentState } from '../../../hooks';
import ToolsBox from "../../components/ToolsBox";
import ToolsTop from "../../../../../../assets/finance/topic900/tools-bj-top.png";
import ToolsBottom from "../../../../../../assets/finance/topic900/tools-bj-bottom.png";
import arrow from "../../../../../../assets/2025/arrow.gif";
import phishing from "../../../../../../assets/finance/topic900/section2_right.png";
import ImgPoint from "../../../../../../assets/2025/arrow.gif";
import link1 from "../../../../../../assets/finance/topic900/link/link1.png";
import link2 from "../../../../../../assets/finance/topic900/link/link2.png";
import link3 from "../../../../../../assets/finance/topic900/link/link3.png";
import link4 from "../../../../../../assets/finance/topic900/link/link4.png";
import play from "../../../../../../assets/finance/topic900/link/play.png";
import { Modal } from 'antd';
interface ISection1Props {
  settings: any;
}

const Section2: React.FunctionComponent<ISection1Props> = ({ settings }) => {
  const ID = '3';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const { updateParagraphState } = useStore();
  const updateComponentState = useUpdateComponentState();
  const paragraphsSettings = useMemo(
    () => settings?.paragraphs[2],
    [settings?.paragraphs]
  );
  const [visibleCount, setVisibleCount] = useState(1);
  const [animationStarted, setAnimationStarted] = useState(false);
  const [activeArr, setActiveArr] = React.useState([0, 1, 2,3]);
  const [state, setState] = React.useState({
    useChecked: [] as any,
    useActive: 0 as any,
  });
  const [open, setOpen] = useState(false);
  const [activeUseItem, setActiveUseItem] = useState<any>(null);
  const linkImageMap: Record<number, string> = {
    1: link1,
    2: link2,
    3: link3,
    4: link4,
  };
  const handleComplete = React.useCallback(() => {
    updateComponentState(
      p_course,
      p_topic,
      ID,
      'finance-topic900-section2-1'
    );
  }, [updateComponentState, p_course, p_topic, ID]);
  const handleArrowClick = React.useCallback(() => {
    if (animationStarted) return;
    setAnimationStarted(true);
    setVisibleCount(2);
    updateComponentState(
      p_course,
      p_topic,
      ID,
      'finance-topic900-section2-2'
    );
  }, [animationStarted, p_course, p_topic, updateComponentState]);
  const getArrayMin = (arr: any, value: any,setArr:any  ) => {
    const newArr = arr.filter((item: any) => item !== value);
    setArr([...newArr]);
    if (!Array.isArray(newArr) || newArr.length === 0) return null;
    return Math.min(...newArr);
  };
  const tapUse = (i: any) => {
    if (!state.useChecked.includes(i)) {
      const min = getArrayMin(activeArr, i,setActiveArr);
      setState({
        ...state,
        useChecked: [...state.useChecked, i],
        useActive: min,
      });
    }
  };
  useEffect(() => {
    if(state.useChecked.length>=4){
      updateComponentState(p_course, p_topic, ID,'finance-topic900-section2-3')
    }
  }, [state.useChecked]);
  const handleLinkClick = (e: React.MouseEvent, item: any, i: number) => {
    e.preventDefault();
    e.stopPropagation();
    setActiveUseItem({ ...item, _index: i + 1 });
    setOpen(true);
  };
  const activeImage =
    linkImageMap[Number(activeUseItem?.id)] ||
    linkImageMap[Number(activeUseItem?._index)] ||
    link1;
  React.useEffect(() => {
    if (!animationStarted || visibleCount >= paragraphsSettings.risks?.length) return;
    const timer = setTimeout(() => setVisibleCount((v) => v + 1), 600);
    return () => clearTimeout(timer);
  }, [visibleCount, animationStarted, paragraphsSettings.risks?.length]);
  return (
    <div className="topic-section-2">
      <CTitle title={paragraphsSettings?.title} />
      <ToolsBox
        leftText={paragraphsSettings?.l1}
        rightText={paragraphsSettings?.l2}
        leftBackgroundImage={ToolsTop}
        rightBackgroundImage={ToolsBottom}
        id="finance-topic900-section2-1"
        onComplete={handleComplete}
      />
      <div className="account-management">
        <div className="content" id="finance-topic900-section2-2">
          {!animationStarted && (
            <img className="arrow-img" src={arrow} alt="" />
          )}
          <div className="left-list" onClick={handleArrowClick}>
            {paragraphsSettings.risks?.map((r: any, i: number) => (
              <div
                key={i}
                className="risk-item"
                data-show={i < visibleCount}
                style={{
                  cursor: i === 0 && !animationStarted ? 'pointer' : 'default',
                }}
              >
                <div className="risk-title">{r.title}</div>
                <div className="risk-desc">{r.desc}</div>
              </div>
            ))}
          </div>
          <div className="m-left-list" onClick={handleArrowClick}>
            {paragraphsSettings.risks?.map((r: any, i: number) => (
              <div
                key={i}
                className="risk-item"
                data-show={i < visibleCount}
                style={{
                  cursor: i === 0 && !animationStarted ? 'pointer' : 'default',
                }}
              >
                <div className="risk-title">{r.title}</div>
                <div className="risk-desc">{r.desc}</div>
              </div>
            ))}
          </div>
          <div className="right-pic">
            <div className="risks-title">{paragraphsSettings?.risksTitle}</div>
            <img src={phishing} alt="" />
          </div>
        </div>
      </div>
      <TTitle title={paragraphsSettings?.tetralogyTitle} />
      <div className="issue-content">
        <div className="silder-list">
          {paragraphsSettings?.tetralogyList?.map((item: any, i: number) => (
            <div className="silder-list-item" key={i}>
              <div className="hexagon">{i + 1}</div>
              <div className="item-left">
                <h3>{item?.title}</h3>
                <p>{item?.desc}</p>
              </div>
            </div>
          ))}
        </div>
        <img className="issue-content-bg" src={QRightBg} alt="" />
      </div>
      <STitle title={paragraphsSettings?.tips}/>
      <div className="use" id="finance-topic900-section2-3">
        <div className="use-action">
          {paragraphsSettings?.tipsList?.map((item: any, i: number) => (
            <div
              className={`use-box ${
                state.useChecked.includes(i) ? 'clicked' : ''
              }`}
              key={i}
            >
              <div className="use-item" onClick={() => tapUse(i)}>
                <div className={`use-item-front front-${i + 1}`}>
                  <div
                    className="use-item-title"
                    dangerouslySetInnerHTML={{ __html: item.title }}
                  />
                  <div className="use-item-content">{item.content}</div>
                  <div className="use-item-subTitle">{item.subTitle}</div>
                  <div className="use-item-desc">{item.desc}</div>
                  <a
                    className="use-item-link"
                    onClick={(e) => handleLinkClick(e, item, i)}
                  >
                    {item.link}
                  </a>
                </div>
                <div className={`use-item-back back-${i + 1}`}>
                  <div
                    className="use-item-title"
                    dangerouslySetInnerHTML={{ __html: item.title }}
                  />
                </div>
                {state.useActive === i && (
                  <img src={ImgPoint} alt="" className="img-point" />
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
      <Modal
        title={''}
        width={'68%'}
        getContainer={false}
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
        wrapClassName="section2-link-modal"
      >
        <div className="news-card">
          <div className="news-header">
            <img src={play} className="news-header-play" alt=""/>
            {activeUseItem?.linkTitle || ''}
          </div>
          <div className="news-content">
            <img className="news-image" src={activeImage} alt={activeUseItem?.linkTitle || 'link image'} />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Section2;
